import { render, staticRenderFns } from "./ArticleSelector.vue?vue&type=template&id=631946e4&scoped=true&"
import script from "./ArticleSelector.vue?vue&type=script&lang=js&"
export * from "./ArticleSelector.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSelector.vue?vue&type=style&index=0&id=631946e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631946e4",
  null
  
)

export default component.exports